import React, { useState, useEffect, useRef } from "react";
import { USER_PROFILE, retrieveData } from "../Utils";
import { Link, useNavigate } from "react-router-dom";
//import Logo from "../images/MCRC_logo.png";
// import Logo from "../images/MCRC_Menu_logo.svg";
import Logo from "../images/Group 9424.png";
//import Logo from "../images/Group 9424.svg"
// import ArrowIcon from "../images/arrowIcon.png";
import ArrowIcon from "../images/arrowicon_green.png";
// import Menu from "../images/Menu.png";
import MenuWhite from "../images/menu_white.svg";
import MenuGreen from "../images/menu_green.svg";
import CentralLogo from "../images/CentralLogo.svg";
import Tracking from "../images/CentralLogo.svg";
import UserMaster from "../images/userMaster.svg";
import FarmlogoSidemenu from "../images/FarmSidemenuLogo.svg";
import MasterIcon from "../images/masterIcon.svg";
import reportsmenuicon from "../images/reportsmenuicon.svg";
import ManPower from "../images/manpoverlogo.svg";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { NavLink } from "react-router-dom";

//for modal
import "bootstrap/dist/css/bootstrap.min.css";
import { useLocation } from "react-router-dom";
import { Activity } from "react-bootstrap-icons";

function SideMenu({ item }) {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [activeItem, setActiveItem] = useState("");
  const [expandedItems, setExpandedItems] = useState([]);

  const [isSubCollapsed, setIsSubCollapsed] = useState(true);
  const [isSubCollapsedItem, setIsCollapsedItem] = useState(true);
  const [selectedSubItem, setSelectedSubItem] = useState("");
  const [isAdmin, setIsAdmin] = useState(true);
  const [isHovered, setIsHovered] = useState(false);

  const navigate = useNavigate();
  const roleTypeName = sessionStorage.getItem("roleTypeName");
  useEffect(() => {
    getSessionData();
    return () => { };
  }, []);

  const getSessionData = async () => {
    const dataFromStore = await retrieveData(USER_PROFILE);
    if (dataFromStore.roleTypeName == "Admin") {
      setIsAdmin(true);
    }
  };
  // for sidebar And Navbar
  const [style, setStyle] = useState(
    "navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
  );

  //Selecetd Side menu ACtive
  const location = useLocation();
  const currentPath = location.pathname;

  const handleItemClick = (item, parents = []) => {
    setActiveItem(item);
    setExpandedItems(parents);
  };

  useEffect(() => {
    const path = window.location.pathname;
    const pathMap = {
      // Central Store
      "/RoleMaster": { item: "RoleMaster", parents: ["collapsePage"] },
      "/UserMaster": { item: "UserMaster", parents: ["collapsePage"] },
      "/MainAssertMaster": { item: "MainAssertMaster", parents: ["collapsePage"] },
      "/AssetMaster": { item: "AssetMaster", parents: ["collapsePage"] },
      "/SubAssetMaster": { item: "SubAssetMaster", parents: ["collapsePage"] },
      "/RoleAssetMapping": { item: "RoleAssetMapping", parents: ["collapsePage"] },
      "/UserMenuControl": { item: "UserMenuControl", parents: ["collapsePage"] },

      //Central Store Masters
      "/UnitMeasureMaster": { item: "UnitMeasureMaster", parents: ["collapsePagesss", "collapsePages"] },
      "/CategoryMaster": { item: "CategoryMaster", parents: ["collapsePagesss", "collapsePages"] },
      "/ProductMaster": { item: "ProductMaster", parents: ["collapsePagesss", "collapsePages"] },
      "/MainStoreMaster": { item: "MainStoreMaster", parents: ["collapsePagesss", "collapsePages"] },
      "/storemaster": { item: "storemaster", parents: ["collapsePagesss", "collapsePages"] },

      // StockInWard
      "/StockInWard": { item: "StockInWard", parents: ["collapseSubPagesss", "collapsePages",] },
      "/OpenStock": { item: "OpenStock", parents: ["collapseSubPagesss", "collapsePages"] },
      "/RequestedOrderHistory": { item: "RequestedOrderHistory", parents: ["collapseSubPagesss", "collapsePages"] },
      "/ReturnOrderHistory": { item: "ReturnOrderHistory", parents: ["collapseSubPagesss", "collapsePages"] },
      "/ProductStatus": { item: "ProductStatus", parents: ["collapseSubPagesss", "collapsePages"] },
      "/history": { item: "history", parents: ["collapseSubPagesss", "collapsePages"] },

      //Reports
      "/stockInwardReport": { item: "stockInwardReport", parents: ["collapsePages", "collapseSubPagesReports"] },
      "/requestReport": { item: "requestReport", parents: ["collapsePages", "collapseSubPagesReports"] },
      "/returnReport": { item: "returnReport", parents: ["collapsePages", "collapseSubPagesReports"] },

      //----------------------------End Central Strore-------------------
      //RM Tracking   
      "/WorkPermit": { item: "WorkPermit", parents: ["collapsePag"] },
      "/RepairMaintenace": { item: "RepairMaintenace", parents: ["collapsePag"] },
      "/NewRequest": { item: "NewRequest", parents: ["collapsePag"] },
      "/DailyWorkAllocation": { item: "DailyWorkAllocation", parents: ["collapsePag"] },
      "/EquipmentMonitoring": { item: "EquipmentMonitoring", parents: ["collapsePag"] },
      "/BulkAllocation": { item: "BulkAllocation", parents: ["collapsePag"] },
      "/RMhistory": { item: "RMhistory", parents: ["collapsePag"] },

      //RM/Masters 
      "/EquipmentLocation": { item: "EquipmentLocation", parents: ["collapsePag", "collapsePagesMasterRM"] },
      "/EquipmentSubLocation": { item: "EquipmentSubLocation", parents: ["collapsePag", "collapsePagesMasterRM"] },
      "/Equipment": { item: "Equipment", parents: ["collapsePag", "collapsePagesMasterRM"] },

      // R&M Reports  
      "/workPermitReport": { item: "workPermitReport", parents: ["collapsePag", "collapseSubPagerm"] },
      "/rMReport": { item: "rMReport", parents: ["collapsePag", "collapseSubPagerm"] },
      "/newRequestReport": { item: "newRequestReport", parents: ["collapsePag", "collapseSubPagerm"] },
      "/DailyWorkAllocationReport": { item: "DailyWorkAllocationReport", parents: ["collapsePag", "collapseSubPagerm"] },
      "/ShiftBasedReport": { item: "ShiftBasedReport", parents: ["collapsePag", "collapseSubPagerm"] },
      "/EquipmentMonitoringReport": { item: "EquipmentMonitoringReport", parents: ["collapsePag", "collapseSubPagerm"] },
      "/BulkAllocationReport": { item: "BulkAllocationReport", parents: ["collapsePag", "collapseSubPagerm"] },

      // Form Operations
      "/RequestFarmOperation": { item: "RequestFarmOperation", parents: ["collapsePagesFarm"] },
      "/UpdateActivity": { item: "UpdateActivity", parents: ["collapsePagesFarm"] },

      // Fo Masters
      "/CropMasters": { item: "CropMasters", parents: ["collapsePagesFarm", "collapsePagesMaster"] },
      "/SubCropMasters": { item: "SubCropMasters", parents: ["collapsePagesFarm", "collapsePagesMaster"] },
      "/SiteMasters": { item: "SiteMasters", parents: ["collapsePagesFarm", "collapsePagesMaster"] },
      "/SubSiteMaster": { item: "SubSiteMaster", parents: ["collapsePagesFarm", "collapsePagesMaster"] },
      "/CropFunction": { item: "CropFunction", parents: ["collapsePagesFarm", "collapsePagesMaster"] },
      "/FunctionMasters": { item: "FunctionMasters", parents: ["collapsePagesFarm", "collapsePagesMaster"] },
      "/SubFunctionMaster": { item: "SubFunctionMaster", parents: ["collapsePagesFarm", "collapsePagesMaster"] },
      "/PlotLocationMaster": { item: "PlotLocationMaster", parents: ["collapsePagesFarm", "collapsePagesMaster"] },
      "/PlotAcrageMasters": { item: "PlotAcrageMasters", parents: ["collapsePagesFarm", "collapsePagesMaster"] },
      "/ChemicalMasters": { item: "ChemicalMasters", parents: ["collapsePagesFarm", "collapsePagesMaster"] },
      "/FertilizerMasters": { item: "FertilizerMasters", parents: ["collapsePagesFarm", "collapsePagesMaster"] },
      "/MainActivity": { item: "MainActivity", parents: ["collapsePagesFarm", "collapsePagesMaster"] },
      "/ActivityMaster": { item: "ActivityMaster", parents: ["collapsePagesFarm", "collapsePagesMaster"] },

      // Machine/System Masters 

      "/DripSystemMaster": { item: "DripSystemMaster", parents: ["collapsePagesMaster", "collapseSubMaters", "collapsePagesFarm",] },
      "/ImplementMaster": { item: "ImplementMaster", parents: ["collapsePagesMaster", "collapseSubMaters", "collapsePagesFarm",] },
      "/DGmaster": { item: "DGmaster", parents: ["collapsePagesMaster", "collapseSubMaters", "collapsePagesFarm",] },
      "/TractorMaster": { item: "TractorMaster", parents: ["collapsePagesMaster", "collapseSubMaters", "collapsePagesFarm",] },
      "/BorewellMaster": { item: "BorewellMaster", parents: ["collapsePagesMaster", "collapseSubMaters", "collapsePagesFarm",] },
      "/SprayerMaster": { item: "SprayerMaster", parents: ["collapsePagesMaster", "collapseSubMaters", "collapsePagesFarm",] },

      // R&M Activity->Machine Systems  
      "/FarmOperationsDripSystem": { item: "FarmOperationsDripSystem", parents: ["collapsePagesFarm", "collapsePagesss", "collapseSubPagesss",] },
      "/FarmOperationsImplements": { item: "FarmOperationsImplements", parents: ["collapsePagesFarm", "collapsePagesss", "collapseSubPagesss",] },
      "/FarmOperationsDG": { item: "FarmOperationsDG", parents: ["collapsePagesFarm", "collapsePagesss", "collapseSubPagesss",] },
      "/FarmOperationsTractors": { item: "FarmOperationsTractors", parents: ["collapsePagesFarm", "collapsePagesss", "collapseSubPagesss",] },
      "/FarmOperationsSprayServices": { item: "FarmOperationsSprayServices", parents: ["collapsePagesFarm", "collapsePagesss", "collapseSubPagesss",] },
      "/FarmOperationsBoreWell": { item: "FarmOperationsBoreWell", parents: ["collapsePagesFarm", "collapsePagesss", "collapseSubPagesss",] },
      "/FarmOperationsGenaralMaintanance": { item: "FarmOperationsGenaralMaintanance", parents: ["collapsePagesFarm", "collapsePagesss", "collapseSubPagesss",] },
      "/FarmOperationHistory": { item: "FarmOperationHistory", parents: ["collapsePagesFarm", "collapsePagesss", "collapseSubPagesss",] },
      "/FarmOperationHistoryAll": { item: "FarmOperationHistoryAll", parents: ["collapsePagesFarm", "collapsePagesss", "collapseSubPagesss",] },
      "/FarmOperationsReports": { item: "FarmOperationsReports", parents: ["collapsePagesFarm", "collapsePagesss", "collapseSubPagesss",] },

      //Manpower  
      "/EmployeeList": { item: "EmployeeList", parents: ["collapsePagesMan"] },
    };
    const config = pathMap[path];
    if (config) {
      setActiveItem(config.item);
      setExpandedItems(config.parents);
    } else {
      setExpandedItems([]);
    }
  }, []);
  const changeStyle = () => {
    if (
      style == "navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
    ) {
      setStyle(
        "navbar-nav bg-gradient-primary sidebar sidebar-dark accordion toggled"
      );
    } else {
      setStyle("navbar-nav bg-gradient-primary sidebar sidebar-dark accordion");
    }
  };
  const changeStyle1 = () => {
    if (
      style == "navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
    ) {
      setStyle(
        "navbar-nav bg-gradient-primary sidebar sidebar-dark accordion toggled1"
      );
    } else {
      setStyle("navbar-nav bg-gradient-primary sidebar sidebar-dark accordion");
    }
  };
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  let itemClicked = sessionStorage.getItem("itemClicked");
  console.log(itemClicked);

  const handleSubItemClick = (subItem) => {
    setSelectedSubItem(subItem);
  };
  const renderSubItem = (subItem, title) => {
    const isSelected = selectedSubItem === subItem;
    const subItemStyle = isSelected ? { backgroundColor: "yellow" } : {};

    return (
      <Link
        to={subItem}
        className={`nav-link collapsed ${isSelected ? "active-link" : ""}`}
        onClick={() => handleSubItemClick(subItem)}
        style={subItemStyle}
      >
        <div>
          <span className="arrow">{isSelected ? "→" : "→"}</span>
          {title}
        </div>
      </Link>
    );
  };

  const determinePath = (item) => {
    const dashboard = sessionStorage.getItem("itemClicked");
    if (dashboard === "centralStore") {
      return '/CentralStoreDashboard';
    } else if (dashboard === "rmTracking") {
      return '/RMDashboard';
    } else if (dashboard === "farmOperations") {
      return '/FarmOperationDashboard';
    }
    return '/defaultPath'; // Fallback path if none of the conditions match MainAssertMaster, 
  };

  const path = determinePath(item);
  return (
    <>
      <ul className={style} id="accordionSidebar">
        {/*  <!-- Sidebar - Brand --> */}
        <div
          className="sidebar-brand ml-3 mr-1 d-flex align-items-center justify-content-center"
          href="#"
        >
          <div className="sidebar-brand-icon rotate-n-15"></div>

          <div
            className="logos sidebar-brand-text mt-1 "
          // style={{ backgroundColor: "white" }}
          >
            <img
              src={Logo}
              alt="MCRC_logo"
              width="220px"
              height="80px"
              quality={100}
              layout="responsive"
              style={{ marginTop: "7px" }}

            />
          </div>
          <div>
            { }
            <img
              className="mcrcbtn"
              quality={100}
              layout="responsive"
              onClick={changeStyle}
              src={ArrowIcon}
            />
          </div>
        </div>
        {/*  <!-- Nav Item - Dashboard --> */}


        <Link
          to={path}
          className="nav-link dashboard-link"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            backgroundColor:
              location.pathname === path || isHovered ? "#FFFFFF" : "transparent",
            color:
              location.pathname === path || isHovered ? "#4A7729" : "white",
            borderRadius: "4px",
            // padding: "10px 17px",
            padding: "10px 10px",
            marginTop: "15px",
            marginBottom: "10px",
            marginLeft: "4px",
            marginRight: "4px",
            display: "flex",
            alignItems: "center",
            gap: "5px",
            transition: "all 0.3s ease",
          }}
        >
          <span style={{ width: "22px", display: "inline-block" }}>
            <img
              src={
                location.pathname === path || isHovered
                  ? MenuGreen
                  : MenuWhite
              }
              alt="Central"
              width="18"
              height="18"
            />
          </span>
          <span
            className="dashboard"
            style={{
              fontSize: "16px",
              fontWeight: 600,
              color:
                location.pathname === path || isHovered
                  ? "#4A7729"
                  : "white",
              marginLeft: "-3px",
            }}
          >
            Dashboard
          </span>
        </Link>

        {isAdmin ? (
          <>
            <>
              {itemClicked === "centralStore" ? (
                <>
                  <li className="centalStr nav-item">
                    <a
                      className={`nav-link ${isCollapsed ? "collapsed" : ""}`}
                      href="#"
                      data-toggle="collapse"
                      data-target="#collapsePage"
                      aria-expanded={isCollapsed ? "false" : "true"}
                      aria-controls="collapsePage"
                    >
                      <span style={{ width: "22px", display: "inline-block" }}>
                        <img
                          src={UserMaster}
                          alt="Tracking"
                          width="18px"
                          height="18px"
                          style={{ transform: "translateX(-3px)" }}
                        />
                      </span>

                      <span
                        style={{ fontSize: 16, marginTop: 4, fontWeight: 600 }}
                      >
                        User Management
                      </span>
                    </a>
                    <div
                      id="collapsePage"
                      className={`collapse ${expandedItems.includes("collapsePage") ? "show" : ""}`}
                      aria-labelledby="headingPages"
                      data-parent="#accordionSidebar"
                    >
                      <div className="userMgt py-2 collapse-inner rounded">
                        <div>
                          <Link
                            to="/RoleMaster"
                            className={`collapse-item ${activeItem === "RoleMaster" ? "active" : ""}`}
                            aria-expanded={activeItem === "RoleMaster" ? "true" : "false"}
                            onClick={() => handleItemClick("RoleMaster", "collapsePage")}
                          >
                            <div>
                              <span className="arrow">&rarr;</span> Role Master
                            </div>
                          </Link>

                          <Link
                            to="/UserMaster"
                            className={`collapse-item ${activeItem === "UserMaster" ? "active" : ""}`}
                            aria-expanded={activeItem === "UserMaster" ? "true" : "false"}
                            onClick={() => handleItemClick("UserMaster", "collapsePage")}
                          >
                            {" "}
                            <div>
                              <span className="arrow">&rarr;</span>User Master
                            </div>
                          </Link>

                          <Link
                            to="/MainAssertMaster"
                            className={`collapse-item ${activeItem === "MainAssertMaster" ? "active" : ""}`}
                            aria-expanded={activeItem === "MainAssertMaster" ? "true" : "false"}
                            onClick={() => handleItemClick("MainAssertMaster", "collapsePage")}
                          >
                            {" "}
                            <div>
                              <span className="arrow">&rarr;</span>Main Asset
                              Master
                            </div>
                          </Link>
                          <Link
                            to="/AssetMaster"
                            className={`collapse-item ${activeItem === "AssetMaster" ? "active" : ""}`}
                            aria-expanded={activeItem === "AssetMaster" ? "true" : "false"}
                            onClick={() => handleItemClick("AssetMaster", "collapsePage")}
                          >
                            {" "}
                            <div>
                              <span className="arrow">&rarr;</span>Asset Master
                            </div>
                          </Link>
                          <Link
                            to="/SubAssetMaster"
                            className={`collapse-item ${activeItem === "SubAssetMaster" ? "active" : ""}`}
                            aria-expanded={activeItem === "SubAssetMaster" ? "true" : "false"}
                            onClick={() => handleItemClick("SubAssetMaster", "collapsePage")}
                          >
                            {" "}
                            <div>
                              <span className="arrow">&rarr;</span>Sub Asset
                              Master
                            </div>
                          </Link>
                          <Link
                            to="/RoleAssetMapping"
                            className={`collapse-item ${activeItem === "RoleAssetMapping" ? "active" : ""}`}
                            aria-expanded={activeItem === "RoleAssetMapping" ? "true" : "false"}
                            onClick={() => handleItemClick("RoleAssetMapping", "collapsePage")}
                          >
                            {" "}
                            <div>
                              <span className="arrow">&rarr;</span>Role Asset
                              Mapping
                            </div>
                          </Link>
                          <Link
                            to="/UserMenuControl"
                            className={`collapse-item ${activeItem === "UserMenuControl" ? "active" : ""}`}
                            aria-expanded={activeItem === "UserMenuControl" ? "true" : "false"}
                            onClick={() => handleItemClick("UserMenuControl", "collapsePage")}
                          >
                            {" "}
                            <div>
                              <span className="arrow">&rarr;</span>User Menu Control
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li className="centalStr nav-item">
                    <a
                      className={`nav-link ${isCollapsed ? "collapsed" : ""}`}
                      href="#"
                      data-toggle="collapse"
                      data-target="#collapsePages"
                      aria-expanded={isCollapsed ? "false" : "true"}
                      aria-controls="collapsePages"
                    >
                      <span style={{ width: "22px", display: "inline-block" }}>
                        <img
                          src={CentralLogo}
                          alt="Tracking"
                          width="18px"
                          height="18px"
                          // style={{ marginRight: "5px", opacity: 3 }}
                          style={{ transform: "translateX(-3px)" }}
                        />
                      </span>
                      <span
                        style={{ fontSize: 16, marginTop: 4, fontWeight: 600 }}
                      >
                        Central Store
                      </span>
                    </a>
                    <div
                      id="collapsePages"
                      // className={`collapse ${isCollapsed ? "" : "show"}`}
                      className={`collapse ${expandedItems.includes("collapsePages") ? "show" : ""}`}
                      aria-labelledby="headingPages"
                      data-parent="#accordionSidebar"
                    >
                      <li className="centalStrAptr nav-item">
                        <a
                          className={`nav-link px-0 ${isCollapsed ? "collapsed" : ""
                            }`}
                          href="#"
                          data-toggle="collapse"
                          data-target="#collapsePagesss"
                          aria-expanded={isCollapsed ? "false" : "true"}
                          aria-controls="collapsePagesss"
                        >
                          <img
                            src={MasterIcon}
                            alt="Tracking"
                            width="15px"
                            height="15px"
                            style={{ marginRight: "5px" }}
                          />
                          <span
                            style={{
                              fontSize: 14,
                              marginTop: 4,
                              fontWeight: 600,
                              marginLeft: "5px",
                            }}
                          >
                            Masters
                          </span>
                        </a>

                        <div
                          id="collapsePagesss"
                          className={`collapse ${expandedItems.includes("collapsePagesss") ? "show" : ""}`}
                          aria-labelledby="headingSubPage"
                          // data-parent="#accordionSidebar"
                          style={{ marginLeft: "3px" }}
                        >
                          <div className="master py-2 collapse-inner rounded">
                            <div classname="active">
                              <Link
                                to="/UnitMeasureMaster"
                                className={`collapse-item ${activeItem === "UnitMeasureMaster" ? "active" : ""}`}
                                aria-expanded={activeItem === "UnitMeasureMaster" ? "true" : "false"}
                                onClick={() => handleItemClick("UnitMeasureMaster", "collapsePages")}
                              >
                                {" "}
                                <div>
                                  <span className="arrow ">&rarr;</span>Unit
                                  Measure Master
                                </div>
                              </Link>
                              <Link
                                to="/CategoryMaster"
                                className={`collapse-item ${activeItem === "CategoryMaster" ? "active" : ""}`}
                                aria-expanded={activeItem === "CategoryMaster" ? "true" : "false"}
                                onClick={() => handleItemClick("CategoryMaster", "collapsePages")}
                              >
                                {" "}
                                <div>
                                  <span className="arrow">&rarr;</span>Category
                                  Master
                                </div>
                              </Link>
                              <Link
                                to="/ProductMaster"
                                className={`collapse-item ${activeItem === "ProductMaster" ? "active" : ""}`}
                                aria-expanded={activeItem === "ProductMaster" ? "true" : "false"}
                                onClick={() => handleItemClick("ProductMaster", "collapsePages")}
                              >
                                {" "}
                                <div>
                                  <span className="arrow">&rarr;</span>Product
                                  Master
                                </div>
                              </Link>
                              <Link
                                to="/MainStoreMaster"
                                className={`collapse-item ${activeItem === "MainStoreMaster" ? "active" : ""}`}
                                aria-expanded={activeItem === "MainStoreMaster" ? "true" : "false"}
                                onClick={() => handleItemClick("MainStoreMaster", "collapsePages")}
                              >
                                {" "}
                                <div>
                                  <span className="arrow">&rarr;</span>Main
                                  Store Master
                                </div>
                              </Link>
                              <Link
                                to="/storemaster"
                                className={`collapse-item ${activeItem === "storemaster" ? "active" : ""}`}
                                aria-expanded={activeItem === "storemaster" ? "true" : "false"}
                                onClick={() => handleItemClick("storemaster", "collapsePages")}
                              >
                                {" "}
                                <div>
                                  <span className="arrow">&rarr;</span>Store
                                  Master
                                </div>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="centalStrAptr nav-item">
                        <a
                          className={`nav-link px-0 ${isCollapsed ? "collapsed" : ""
                            }`}
                          href="#"
                          data-toggle="collapse"
                          data-target="#collapseSubPagesss"
                          aria-expanded={isCollapsed ? "false" : "true"}
                          aria-controls="collapseSubPagesss"
                        >
                          <img
                            src={Tracking}
                            alt="Tracking"
                            width="15px"
                            height="15px"
                            style={{ marginRight: "5px" }}
                          />
                          <span
                            style={{
                              fontSize: 14,
                              marginTop: 4,
                              fontWeight: 600,
                              marginLeft: "5px",
                            }}
                          >
                            Acceptor
                          </span>
                        </a>
                        <div
                          id="collapseSubPagesss"
                          // className={`collapse ${isSubCollapsed ? "" : "show"}`}
                          className={`collapse ${expandedItems.includes("collapseSubPagesss") ? "show" : ""}`}
                          aria-labelledby="headingSubPage"
                          style={{ marginLeft: "3px" }}
                        >
                          <div className="master py-2 collapse-inner rounded">
                            <div>
                              <Link
                                to="/StockInWard"
                                className={`collapse-item ${activeItem === "StockInWard" ? "active" : ""}`}
                                aria-expanded={activeItem === "StockInWard" ? "true" : "false"}
                                onClick={() => handleItemClick("StockInWard", "collapsePages")}
                              >
                                {" "}
                                <div>
                                  <span className="arrow">&rarr;</span>
                                  Stock-In-Ward
                                </div>
                              </Link>

                              <Link
                                to="/OpenStock"
                                className={`collapse-item ${activeItem === "OpenStock" ? "active" : ""}`}
                                aria-expanded={activeItem === "OpenStock" ? "true" : "false"}
                                onClick={() => handleItemClick("OpenStock", "collapsePages")}
                              >
                                {" "}
                                <div>
                                  <span className="arrow">&rarr;</span>Open
                                  Stock
                                </div>
                              </Link>

                              <Link
                                to="/RequestedOrderHistory"
                                className={`collapse-item ${activeItem === "RequestedOrderHistory" ? "active" : ""}`}
                                aria-expanded={activeItem === "RequestedOrderHistory" ? "true" : "false"}
                                onClick={() => handleItemClick("RequestedOrderHistory", "collapsePages")}
                              >
                                {" "}
                                <div>
                                  <span className="arrow">&rarr;</span>Requests
                                </div>
                              </Link>

                              <Link
                                to="/ReturnOrderHistory"
                                className={`collapse-item ${activeItem === "ReturnOrderHistory" ? "active" : ""}`}
                                aria-expanded={activeItem === "ReturnOrderHistory" ? "true" : "false"}
                                onClick={() => handleItemClick("ReturnOrderHistory", "collapsePages")}
                              >
                                {" "}
                                <div>
                                  <span className="arrow">&rarr;</span>Returns
                                </div>
                              </Link>
                              <Link
                                to="/ProductStatus"
                                className={`collapse-item ${activeItem === "ProductStatus" ? "active" : ""}`}
                                aria-expanded={activeItem === "ProductStatus" ? "true" : "false"}
                                onClick={() => handleItemClick("ProductStatus", "collapsePages")}
                              >
                                {" "}
                                <div>
                                  <span className="arrow">&rarr;</span>Product
                                  Status
                                </div>
                              </Link>
                              <Link
                                to="/history"
                                className={`collapse-item ${activeItem === "history" ? "active" : ""}`}
                                aria-expanded={activeItem === "history" ? "true" : "false"}
                                onClick={() => handleItemClick("history", "collapsePages")}
                              >
                                {" "}
                                <div>
                                  <span className="arrow">&rarr;</span>
                                  History
                                </div>
                              </Link>

                            </div>
                          </div>
                        </div>
                      </li>
                      <div>
                        {/* Cs Reports */}
                        <li className="centalStrAptr nav-item">
                          <a
                            className={`nav-link px-0 ${isCollapsed ? "collapsed" : ""
                              }`}
                            href="#"
                            data-toggle="collapse"
                            data-target="#collapseSubPagesReports"
                            aria-expanded={isCollapsed ? "false" : "true"}
                            aria-controls="collapseSubPagesReports"
                          >
                            <img
                              src={reportsmenuicon}
                              alt="reportsmenuicon"
                              width="15px"
                              height="15px"
                              style={{ marginRight: "5px" }}
                            />
                            <span
                              style={{
                                fontSize: 14,
                                marginTop: 4,
                                fontWeight: 600,
                                marginLeft: "5px",
                              }}
                            >
                              Reports
                            </span>
                          </a>
                          <div
                            id="collapseSubPagesReports"
                            // className={`collapse ${isSubCollapsed ? "" : "show"
                            //   }`}
                            className={`collapse ${expandedItems.includes("collapseSubPagesReports") ? "show" : ""}`}
                            aria-labelledby="headingSubPage"
                            //  data-parent="#collapsePages"
                            style={{ marginLeft: "3px" }}
                          >
                            <div className="master py-2 collapse-inner rounded">
                              <div>
                                <Link
                                  to="/stockInwardReport"
                                  className={`collapse-item ${activeItem === "stockInwardReport" ? "active" : ""}`}
                                  aria-expanded={activeItem === "stockInwardReport" ? "true" : "false"}
                                  onClick={() => handleItemClick("stockInwardReport", "collapsePages")}
                                >
                                  {" "}
                                  <div>
                                    <span className="arrow">&rarr;</span>
                                    Stock-In-ward
                                  </div>
                                </Link>
                                <Link
                                  to="/requestReport"
                                  className={`collapse-item ${activeItem === "requestReport" ? "active" : ""}`}
                                  aria-expanded={activeItem === "requestReport" ? "true" : "false"}
                                  onClick={() => handleItemClick("requestReport", "collapsePages")}
                                >
                                  {" "}
                                  <div>
                                    <span className="arrow">&rarr;</span>
                                    Request
                                  </div>
                                </Link>
                                <Link
                                  to="/returnReport"
                                  className={`collapse-item ${activeItem === "returnReport" ? "active" : ""}`}
                                  aria-expanded={activeItem === "returnReport" ? "true" : "false"}
                                  onClick={() => handleItemClick("returnReport", "collapsePages")}
                                >
                                  {" "}
                                  <div>
                                    <span className="arrow">&rarr;</span>
                                    Return
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </li>
                      </div>
                    </div>
                  </li>
                </>
              ) : (
                ""
              )}
            </>
            {/* rmTracking */}
            <>
              {itemClicked === "rmTracking" ? (
                <li className="centalStr nav-item">
                  <a
                    className={`nav-link ${isCollapsed ? "collapsed" : ""}`}
                    href="#"
                    data-toggle="collapse"
                    data-target="#collapsePag"
                    aria-expanded={isCollapsed ? "false" : "true"}
                    aria-controls="collapsePag"
                  >
                    <img
                      src={UserMaster}
                      alt="Tracking"
                      width="22px"
                      height="20px"
                      style={{ marginRight: "5px", marginLeft: "-3px" }}
                    />
                    <span style={{ fontWeight: 900 }}>R & M Tracking</span>
                  </a>
                  <div
                    id="collapsePag"
                    className={`collapse ${expandedItems.includes("collapsePag") ? "show" : ""}`}
                    aria-labelledby="headingPages"
                    data-parent="#accordionSidebar"
                  >
                    <div className="userMgt py-2 collapse-inner rounded">
                      <div>
                        <Link
                          to="/WorkPermit"
                          className={`collapse-item ${activeItem === "WorkPermit" ? "active" : ""}`}
                          aria-expanded={activeItem === "WorkPermit" ? "true" : "false"}
                          onClick={() => handleItemClick("WorkPermit", "collapsePag")}
                        >
                          {" "}
                          <div>
                            <span className="arrow">&rarr;</span>Work Permit
                          </div>
                        </Link>
                        <Link
                          to="/RepairMaintenace"
                          className={`collapse-item ${activeItem === "RepairMaintenace" ? "active" : ""}`}
                          aria-expanded={activeItem === "RepairMaintenace" ? "true" : "false"}
                          onClick={() => handleItemClick("RepairMaintenace", "collapsePag")}
                        >
                          {" "}
                          <div>
                            <span className="arrow">&rarr;</span>R & M
                          </div>
                        </Link>
                        <Link
                          to="/NewRequest"
                          className={`collapse-item ${activeItem === "NewRequest" ? "active" : ""}`}
                          aria-expanded={activeItem === "NewRequest" ? "true" : "false"}
                          onClick={() => handleItemClick("NewRequest", "collapsePag")}
                        >
                          {" "}
                          <div>
                            <span className="arrow">&rarr;</span>New Requests
                          </div>
                        </Link>
                        <Link
                          to="/DailyWorkAllocation"
                          className={`collapse-item ${activeItem === "DailyWorkAllocation" ? "active" : ""}`}
                          aria-expanded={activeItem === "DailyWorkAllocation" ? "true" : "false"}
                          onClick={() => handleItemClick("DailyWorkAllocation", "collapsePag")}
                        >
                          {" "}
                          <div>
                            <span className="arrow">&rarr;</span>Daily Work
                            Allocation
                          </div>
                        </Link>
                        <Link
                          to="/EquipmentMonitoring"
                          className={`collapse-item ${activeItem === "EquipmentMonitoring" ? "active" : ""}`}
                          aria-expanded={activeItem === "EquipmentMonitoring" ? "true" : "false"}
                          onClick={() => handleItemClick("EquipmentMonitoring", "collapsePag")}
                        >
                          {" "}
                          <div>
                            <span className="arrow">&rarr;</span>Preventive
                            Maintenance
                          </div>
                        </Link>
                        <Link
                          to="/BulkAllocation"
                          className={`collapse-item ${activeItem === "BulkAllocation" ? "active" : ""}`}
                          aria-expanded={activeItem === "BulkAllocation" ? "true" : "false"}
                          onClick={() => handleItemClick("BulkAllocation", "collapsePag")}
                        >
                          {" "}
                          <div>
                            <span className="arrow">&rarr;</span>Bulk Allocation
                          </div>
                        </Link>
                        <Link
                          to="/RMhistory"
                          className={`collapse-item ${activeItem === "RMhistory" ? "active" : ""}`}
                          aria-expanded={activeItem === "RMhistory" ? "true" : "false"}
                          onClick={() => handleItemClick("RMhistory", "collapsePag")}
                        >
                          {" "}
                          <div>
                            <span className="arrow">&rarr;</span>History
                          </div>
                        </Link>
                        <li className="centalStrAptr nav-item">
                          <a
                            className={`nav-link px-0 ${isCollapsed ? "collapsed" : ""
                              }`}
                            href="#"
                            data-toggle="collapse"
                            data-target="#collapsePagesMasterRM"
                            aria-expanded={isCollapsed ? "false" : "true"}
                            aria-controls="collapsePagesMasterRM"
                            style={{ marginTop: "11px", }}
                          >

                            <img
                              src={ManPower}
                              alt="Tracking"
                              width="17px"
                              height="18px"
                              style={{ marginRight: "5px", marginBottom: "6px" }}
                            />
                            <span style={{ fontSize: 14, marginTop: 4, fontWeight: 900, color: "white", marginLeft: "3px", }}>
                              Masters
                            </span>
                          </a>
                          <div
                            id="collapsePagesMasterRM"
                            // className={`collapse ${expandedItems.includes("collapsePagesMasterRM") ? "show" : ""}`}
                            className={`collapse ${expandedItems.includes("collapsePagesMasterRM") ? "show" : ""}`}
                            aria-labelledby="headingPages"
                            style={{ marginLeft: "0", marginRight: "0" }}
                          >
                            <div className="master py-2">
                              <Link
                                to="/EquipmentLocation"
                                className={`collapse-item ${activeItem === "EquipmentLocation" ? "active" : ""}`}
                                aria-expanded={activeItem === "EquipmentLocation" ? "true" : "false"}
                                onClick={() => handleItemClick("EquipmentLocation", "collapsePag")}
                              >
                                <div>
                                  <span className="arrow">&rarr;</span> Equipment Location
                                </div>
                              </Link>
                              <Link
                                to="/EquipmentSubLocation"
                                className={`collapse-item ${activeItem === "EquipmentSubLocation" ? "active" : ""}`}
                                aria-expanded={activeItem === "EquipmentSubLocation" ? "true" : "false"}
                                onClick={() => handleItemClick("EquipmentSubLocation", "collapsePag")}
                              >
                                <div>
                                  <span className="arrow">&rarr;</span> Equipment SubLocation
                                </div>
                              </Link>
                              <Link
                                to="/Equipment"
                                className={`collapse-item ${activeItem === "Equipment" ? "active" : ""}`}
                                aria-expanded={activeItem === "Equipment" ? "true" : "false"}
                                onClick={() => handleItemClick("Equipment", "collapsePag")}
                              >
                                <div>
                                  <span className="arrow">&rarr;</span> Equipment
                                </div>
                              </Link>
                            </div>
                          </div>
                        </li>

                        {/* R&M Reports */}
                        <div style={{ marginTop: "-10px" }}>
                          <li>
                            <a
                              className={`nav-link px-0
                              ${isCollapsed ? "collapsed" : ""}`}
                              href="#"
                              data-toggle="collapse"
                              data-target="#collapseSubPagerm"
                              aria-expanded={isCollapsed ? "false" : "true"}
                              aria-controls="collapseSubPagerm"
                              style={{ width: "100%" }}
                            >
                              <img
                                src={reportsmenuicon}
                                alt="reportsmenuicon"
                                width="15px"
                                height="15px"
                                style={{
                                  marginRight: "5px",
                                  width: "20px",
                                  height: "22px",
                                }}
                              />
                              <span
                                style={{
                                  fontSize: 14,
                                  marginTop: 4,
                                  fontWeight: 600,
                                  marginLeft: "3px",
                                  color: "white",
                                }}
                              >
                                Reports
                              </span>
                            </a>
                            <div
                              id="collapseSubPagerm"
                              className={`collapse ${expandedItems.includes("collapseSubPagerm") ? "show" : ""}`}
                              aria-labelledby="headingSubPage"
                              style={{ marginLeft: "3px" }}
                            >
                              <div className="master py-2 ">
                                <div>

                                  <Link
                                    to="/workPermitReport"
                                    className={`collapse-item ${activeItem === "workPermitReport" ? "active" : ""}`}
                                    aria-expanded={activeItem === "workPermitReport" ? "true" : "false"}
                                    onClick={() => handleItemClick("workPermitReport", "collapsePag")}
                                  >
                                    <div>
                                      <span className="arrow">&rarr;</span> Work Permit
                                    </div>
                                  </Link>

                                  <Link
                                    to="/rMReport"
                                    className={`collapse-item ${activeItem === "rMReport" ? "active" : ""}`}
                                    aria-expanded={activeItem === "rMReport" ? "true" : "false"}
                                    onClick={() => handleItemClick("rMReport", "collapsePag")}
                                  >
                                    <div>
                                      <span className="arrow">&rarr;</span>R&M
                                    </div>
                                  </Link>

                                  <Link
                                    to="/newRequestReport"
                                    className={`collapse-item ${activeItem === "newRequestReport" ? "active" : ""}`}
                                    aria-expanded={activeItem === "newRequestReport" ? "true" : "false"}
                                    onClick={() => handleItemClick("newRequestReport", "collapsePag")}
                                  >
                                    <div>
                                      <span className="arrow">&rarr;</span>New Request
                                    </div>
                                  </Link>
                                  <Link
                                    to="/DailyWorkAllocationReport"
                                    className={`collapse-item ${activeItem === "DailyWorkAllocationReport" ? "active" : ""}`}

                                    aria-expanded={activeItem === "DailyWorkAllocationReport" ? "true" : "false"}
                                    onClick={() => handleItemClick("DailyWorkAllocationReport", "collapsePag")}
                                  >
                                    <div>
                                      <span className="arrow">&rarr;</span>Daily Work Allocation
                                    </div>
                                  </Link>
                                  <Link
                                    to="/ShiftBasedReport"
                                    className={`collapse-item ${activeItem === "ShiftBasedReport" ? "active" : ""}`}
                                    aria-expanded={activeItem === "ShiftBasedReport" ? "true" : "false"}
                                    onClick={() => handleItemClick("ShiftBasedReport", "collapsePag")}
                                  >
                                    <div>
                                      <span className="arrow">&rarr;</span>Shift Based
                                    </div>
                                  </Link>
                                  <Link
                                    to="/EquipmentMonitoringReport"
                                    className={`collapse-item ${activeItem === "EquipmentMonitoringReport" ? "active" : ""}`}
                                    aria-expanded={activeItem === "EquipmentMonitoringReport" ? "true" : "false"}
                                    onClick={() => handleItemClick("EquipmentMonitoringReport", "collapsePag")}
                                  >
                                    <div>
                                      <span className="arrow">&rarr;</span>Preventive Maintenance
                                    </div>
                                  </Link>
                                  <Link
                                    to="/BulkAllocationReport"
                                    className={`collapse-item ${activeItem === "BulkAllocationReport" ? "active" : ""}`}
                                    aria-expanded={activeItem === "BulkAllocationReport" ? "true" : "false"}
                                    onClick={() => handleItemClick("BulkAllocationReport", "collapsePag")}
                                  >
                                    <div>
                                      <span className="arrow">&rarr;</span>BulkAllocation
                                    </div>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </li>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              ) : (
                ""
              )}
            </>
            <>
              {itemClicked === "farmOperations" ? (
                <li className="centalStr nav-item">
                  <a
                    className={`nav-link ${isCollapsed ? "collapsed" : ""}`}
                    href="#"
                    data-toggle="collapse"
                    data-target="#collapsePagesFarm"
                    aria-expanded={isCollapsed ? "false" : "true"}
                    aria-controls="collapsePagesFarm"
                  // onClick={toggleCollapse}
                  >
                    <span style={{ width: "22px", display: "inline-block" }}>
                      <img
                        src={FarmlogoSidemenu}
                        alt="Tracking"
                        width="17px"
                        height="18px"
                        style={{ marginRight: "5px", marginBottom: "6px" }}
                      />
                    </span>
                    <span
                      style={{ fontSize: 16, marginTop: 4, fontWeight: 600, marginLeft: "1px" }}
                    >
                      Farm Operations
                    </span>
                  </a>
                  <div
                    id="collapsePagesFarm"
                    // className={`collapse ${isCollapsed ? "" : "show"}`}
                    className={`collapse ${expandedItems.includes("collapsePagesFarm") ? "show" : ""}`}
                    aria-labelledby="headingPages"
                    data-parent="#accordionSidebar"
                  >
                    <div className="centalStrAptr py-2 collapse-inner rounded">

                      <Link
                        to="/RequestFarmOperation"
                        className={`collapse-item ${activeItem === "RequestFarmOperation" ? "active" : ""}`}
                        aria-expanded={activeItem === "RequestFarmOperation" ? "true" : "false"}
                        onClick={() => handleItemClick("RequestFarmOperation", "collapsePagesFarm")}
                      >
                        <div>
                          <span className="arrow">&rarr;</span>Requests
                        </div>
                      </Link>
                      <Link
                        to="/UpdateActivity"
                        className={`collapse-item ${activeItem === "UpdateActivity" ? "active" : ""}`}
                        aria-expanded={activeItem === "UpdateActivity" ? "true" : "false"}
                        onClick={() => handleItemClick("UpdateActivity", "collapsePagesFarm")}
                      >
                        <div>
                          <span className="arrow">&rarr;</span>Update Activity
                        </div>
                      </Link>
                      <li className="centalStrAptr nav-item">
                        <a
                          className={`nav-link px-0 ${isCollapsed ? "collapsed" : ""
                            }`}
                          href="#"
                          data-toggle="collapse"
                          data-target="#collapsePagesMaster"
                          aria-expanded={isCollapsed ? "false" : "true"}
                          aria-controls="collapsePagesMaster"
                          style={{ marginTop: "11px", }}
                        >
                          <img
                            src={ManPower}
                            alt="Tracking"
                            width="17px"
                            height="18px"
                            style={{ marginRight: "8px", marginBottom: "6px" }}
                          />
                          <span style={{ fontSize: 14, marginTop: 4, fontWeight: 900, color: "white", }}>
                            Masters
                          </span>
                        </a>
                        <div
                          id="collapsePagesMaster"
                          className={`collapse ${expandedItems.includes("collapsePagesMaster") ? "show" : ""}`}
                          aria-labelledby="headingPages"
                          style={{ marginLeft: "0", marginRight: "0" }}
                        >
                          <div className="centalStrAptr py-2 collapse-inner rounded">
                            <Link
                              to="/CropMasters"
                              className={`collapse-item ${activeItem === "CropMasters" ? "active" : ""}`}
                              aria-expanded={activeItem === "CropMasters" ? "true" : "false"}
                              onClick={() => handleItemClick("CropMasters", "collapsePagesMaster")}
                            >
                              <div>
                                <span className="arrow">&rarr;</span>Crop
                              </div>
                            </Link>

                            <Link
                              to="/SubCropMasters"
                              className={`collapse-item ${activeItem === "SubCropMasters" ? "active" : ""}`}
                              aria-expanded={activeItem === "SubCropMasters" ? "true" : "false"}
                              onClick={() => handleItemClick("SubCropMasters", "collapsePagesMaster")}
                            >
                              <div>
                                <span className="arrow">&rarr;</span>SubCrop
                              </div>
                            </Link>

                            <Link
                              to="/SiteMasters"
                              className={`collapse-item ${activeItem === "SiteMasters" ? "active" : ""}`}

                              aria-expanded={activeItem === "SiteMasters" ? "true" : "false"}
                              onClick={() => handleItemClick("SiteMasters", "collapsePagesMaster")}
                            >
                              <div>
                                <span className="arrow">&rarr;</span>Main Site
                              </div>
                            </Link>

                            <Link
                              to="/SubSiteMaster"
                              className={`collapse-item ${activeItem === "SubSiteMaster" ? "active" : ""}`}

                              aria-expanded={activeItem === "SubSiteMaster" ? "true" : "false"}
                              onClick={() => handleItemClick("SubSiteMaster", "collapsePagesMaster")}
                            >
                              <div>
                                <span className="arrow">&rarr;</span>SubSite
                              </div>
                            </Link>
                            <Link
                              to="/CropFunction"
                              className={`collapse-item ${activeItem === "CropFunction" ? "active" : ""}`}
                              aria-expanded={activeItem === "CropFunction" ? "true" : "false"}
                              onClick={() => handleItemClick("CropFunction", "collapsePagesMaster")}
                            >
                              <div>
                                <span className="arrow">&rarr;</span>Crop Function
                              </div>
                            </Link>
                            <Link
                              to="/FunctionMasters"
                              className={`collapse-item ${activeItem === "FunctionMasters" ? "active" : ""}`}
                              aria-expanded={activeItem === "FunctionMasters" ? "true" : "false"}
                              onClick={() => handleItemClick("CropFunction", "collapsePagesMaster")}
                            >
                              <div>
                                <span className="arrow">&rarr;</span>Function
                              </div>
                            </Link>

                            <Link
                              to="/SubFunctionMaster"
                              className={`collapse-item ${activeItem === "SubFunctionMaster" ? "active" : ""}`}
                              aria-expanded={activeItem === "SubFunctionMaster" ? "true" : "false"}
                              onClick={() => handleItemClick("SubFunctionMaster", "collapsePagesMaster")}
                            >
                              <div>
                                <span className="arrow">&rarr;</span>SubFunction
                              </div>
                            </Link>
                            <Link
                              to="/PlotLocationMaster"
                              className={`collapse-item ${activeItem === "PlotLocationMaster" ? "active" : ""}`}
                              aria-expanded={activeItem === "PlotLocationMaster" ? "true" : "false"}
                              onClick={() => handleItemClick("PlotLocationMaster", "collapsePagesMaster")}
                            >
                              <div>
                                <span className="arrow">&rarr;</span>Plot Location
                              </div>
                            </Link>

                            <Link
                              to="/PlotAcrageMasters"
                              className={`collapse-item ${activeItem === "PlotAcrageMasters" ? "active" : ""}`}
                              aria-expanded={activeItem === "PlotAcrageMasters" ? "true" : "false"}
                              onClick={() => handleItemClick("PlotAcrageMasters", "collapsePagesMaster")}
                            >
                              <div>
                                <span className="arrow">&rarr;</span>Plot Acreage
                              </div>
                            </Link>
                            <Link
                              to="/ChemicalMasters"
                              className={`collapse-item ${activeItem === "ChemicalMasters" ? "active" : ""}`}
                              aria-expanded={activeItem === "ChemicalMasters" ? "true" : "false"}
                              onClick={() => handleItemClick("ChemicalMasters", "collapsePagesMaster")}
                            >
                              <div>
                                <span className="arrow">&rarr;</span>Chemical
                              </div>
                            </Link>
                            <Link
                              to="/FertilizerMasters"
                              className={`collapse-item ${activeItem === "FertilizerMasters" ? "active" : ""}`}
                              aria-expanded={activeItem === "FertilizerMasters" ? "true" : "false"}
                              onClick={() => handleItemClick("FertilizerMasters", "collapsePagesMaster")}
                            >
                              <div>
                                <span className="arrow">&rarr;</span>Fertilizer
                              </div>
                            </Link>
                            <Link
                              to="/MainActivity"
                              className={`collapse-item ${activeItem === "MainActivity" ? "active" : ""}`}
                              aria-expanded={activeItem === "MainActivity" ? "true" : "false"}
                              onClick={() => handleItemClick("MainActivity", "collapsePagesMaster")}
                            >
                              <div>
                                <span className="arrow">&rarr;</span>Category
                              </div>
                            </Link>
                            <Link
                              to="/ActivityMaster"
                              className={`collapse-item ${activeItem === "ActivityMaster" ? "active" : ""}`}
                              aria-expanded={activeItem === "MainActivity" ? "true" : "false"}
                              onClick={() => handleItemClick("ActivityMaster", "collapsePagesMaster")}
                            >
                              <div>
                                <span className="arrow">&rarr;</span>Sub Category
                              </div>
                            </Link>
                          </div>
                        </div>
                        <div
                          id="collapsePagesMaster"
                          // className={`collapse ${isSubCollapsed ? "" : "show"}`}
                          className={`collapse ${expandedItems.includes("collapsePagesMaster") ? "show" : ""}`}
                          aria-labelledby="headingSubPage"
                          style={{ marginLeft: "0", marginRight: "0" }}
                        >
                          <div className="master py-2 collapse-inner rounded mt-0">
                            <li className="centalStrAptr nav-item">
                              <a
                                className={`nav-link px-0 ${isCollapsed ? "collapsed" : ""
                                  }`}
                                href="#"
                                data-toggle="collapse"
                                data-target="#collapseSubMaters"
                                aria-expanded={isCollapsed ? "false" : "true"}
                                aria-controls="collapseSubMaters"
                                style={{ marginTop: "30px", fontWeight: 600 }}  >
                                <span
                                  className="arrow mt-3"
                                  style={{ fontSize: 11, fontWeight: 600 }}
                                >
                                  &rarr;
                                </span>
                                Machine/System Masters
                              </a>
                              <div id="collapseSubMaters"
                                className={`collapse ${expandedItems.includes("collapseSubMaters") ? "show" : ""}`}
                                aria-labelledby="headingSubPage"
                                style={{ marginLeft: "3px" }} >
                                <div className="master py-2 collapse-inner rounded">
                                  <div>
                                    <Link
                                      to="/DripSystemMaster"
                                      className={`collapse-item ${activeItem === "DripSystemMaster" ? "active" : ""}`}
                                      aria-expanded={activeItem === "DripSystemMaster" ? "true" : "false"}
                                      onClick={() => handleItemClick("DripSystemMaster", "collapsePagesMaster")}
                                    >
                                      <div>
                                        <span className="arrow">&rarr;</span>Drip System
                                      </div>
                                    </Link>

                                    <Link
                                      to="/ImplementMaster"
                                      className={`collapse-item ${activeItem === "ImplementMaster" ? "active" : ""}`}
                                      aria-expanded={activeItem === "ImplementMaster" ? "true" : "false"}
                                      onClick={() => handleItemClick("ImplementMaster", "collapsePagesMaster")}
                                    >
                                      <div>
                                        <span className="arrow">&rarr;</span>Implement
                                      </div>
                                    </Link>
                                    <Link
                                      to="/DGmaster"
                                      className={`collapse-item ${activeItem === "DGmaster" ? "active" : ""}`}
                                      aria-expanded={activeItem === "DGmaster" ? "true" : "false"}
                                      onClick={() => handleItemClick("DGmaster", "collapsePagesMaster")}
                                    >
                                      <div>
                                        <span className="arrow">&rarr;</span>DG Master
                                      </div>
                                    </Link>
                                    <Link
                                      to="/TractorMaster"
                                      className={`collapse-item ${activeItem === "TractorMaster" ? "active" : ""}`}
                                      aria-expanded={activeItem === "TractorMaster" ? "true" : "false"}
                                      onClick={() => handleItemClick("TractorMaster", "collapsePagesMaster")}
                                    >
                                      <div>
                                        <span className="arrow">&rarr;</span>Tractor
                                      </div>
                                    </Link>
                                    <Link
                                      to="/BorewellMaster"
                                      className={`collapse-item ${activeItem === "BorewellMaster" ? "active" : ""}`}
                                      aria-expanded={activeItem === "BorewellMaster" ? "true" : "false"}
                                      onClick={() => handleItemClick("BorewellMaster", "collapsePagesMaster")}
                                    >
                                      <div>
                                        <span className="arrow">&rarr;</span>BoreWell
                                      </div>
                                    </Link>
                                    <Link
                                      to="/SprayerMaster"
                                      className={`collapse-item ${activeItem === "SprayerMaster" ? "active" : ""}`}
                                      aria-expanded={activeItem === "SprayerMaster" ? "true" : "false"}
                                      onClick={() => handleItemClick("SprayerMaster", "collapsePagesMaster")}
                                    >
                                      <div>
                                        <span className="arrow">&rarr;</span>Sprayers
                                      </div>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </div>
                        </div>
                      </li>
                      <li className="centalStrAptr nav-item">
                        <a
                          className={`nav-link px-0 ${isCollapsed ? "collapsed" : ""
                            }`}
                          href="#"
                          data-toggle="collapse"
                          data-target="#collapsePagesss"
                          aria-expanded={isCollapsed ? "false" : "true"}
                          aria-controls="collapsePagesss"
                          style={{ marginTop: "-20px" }}
                        >

                          <img
                            src={MasterIcon}
                            alt="Tracking"
                            width="18px"
                            height="18px"
                            style={{
                              marginRight: "5px",
                              marginTop: "-9px", // Moves image up
                            }}
                          />
                          <span
                            style={{
                              fontSize: 14,
                              marginTop: 4,
                              fontWeight: 600,
                              marginLeft: "3px",
                              color: "white",
                            }}
                          >
                            R&M Activity
                          </span>
                        </a>
                        <div
                          id="collapsePagesss"
                          //className={`collapse ${isSubCollapsed ? "" : "show"}`}
                          className={`collapse ${expandedItems.includes("collapsePagesss") ? "show" : ""}`}
                          aria-labelledby="headingSubPage"
                          //  data-parent="#collapsePages"
                          style={{ marginLeft: "0", marginRight: "0" }}
                        >
                          <div className="master py-2 collapse-inner rounded mt-0">
                            <li className="centalStrAptr nav-item">
                              <a
                                className={`nav-link px-0 ${isCollapsed ? "collapsed" : ""
                                  }`}
                                href="#"
                                data-toggle="collapse"
                                data-target="#collapseSubPagesss"
                                aria-expanded={isCollapsed ? "false" : "true"}
                                aria-controls="collapseSubPagesss"
                                style={{
                                  marginTop: "13px", fontWeight: 600
                                }}
                              >
                                <span
                                  className="arrow mt-3"
                                  style={{ fontSize: 14, fontWeight: 600 }}
                                >
                                  &rarr;
                                </span>
                                Machines/Systems
                              </a>
                              <div
                                id="collapseSubPagesss"
                                className={`collapse ${expandedItems.includes("collapseSubPagesss") ? "show" : ""}`}
                                aria-labelledby="headingSubPage"
                                //  data-parent="#collapsePages"
                                style={{
                                  marginLeft: "3px"
                                }}
                              >
                                <div className="master py-2 collapse-inner rounded">
                                  <div>
                                    <Link
                                      to="/FarmOperationsDripSystem"
                                      className={`collapse-item ${activeItem === "FarmOperationsDripSystem" ? "active" : ""}`}
                                      aria-expanded={activeItem === "FarmOperationsDripSystem" ? "true" : "false"}
                                      onClick={() => handleItemClick("FarmOperationsDripSystem", "collapsePagesss")}
                                    >
                                      <div>
                                        <span className="arrow">&rarr;</span>Drip Systems
                                      </div>
                                    </Link>
                                    <Link
                                      to="/FarmOperationsImplements"
                                      className={`collapse-item ${activeItem === "FarmOperationsImplements" ? "active" : ""}`}
                                      aria-expanded={activeItem === "FarmOperationsImplements" ? "true" : "false"}
                                      onClick={() => handleItemClick("FarmOperationsImplements", "collapsePagesss")}
                                    >
                                      <div>
                                        <span className="arrow">&rarr;</span>Implements
                                      </div>
                                    </Link>
                                    <Link
                                      to="/FarmOperationsDG"
                                      className={`collapse-item ${activeItem === "FarmOperationsDG" ? "active" : ""}`}
                                      aria-expanded={activeItem === "FarmOperationsDG" ? "true" : "false"}
                                      onClick={() => handleItemClick("FarmOperationsDG", "collapsePagesss")}
                                    >
                                      <div>
                                        <span className="arrow">&rarr;</span>DG
                                      </div>
                                    </Link>
                                    <Link
                                      to="/FarmOperationsTractors"
                                      className={`collapse-item ${activeItem === "FarmOperationsTractors" ? "active" : ""}`}
                                      aria-expanded={activeItem === "FarmOperationsTractors" ? "true" : "false"}
                                      onClick={() => handleItemClick("FarmOperationsTractors", "collapsePagesss")}
                                    >
                                      <div>
                                        <span className="arrow">&rarr;</span>Tractors
                                      </div>
                                    </Link>
                                    <Link
                                      to="/FarmOperationsSprayServices"
                                      className={`collapse-item ${activeItem === "FarmOperationsSprayServices" ? "active" : ""}`}
                                      aria-expanded={activeItem === "FarmOperationsSprayServices" ? "true" : "false"}
                                      onClick={() => handleItemClick("FarmOperationsSprayServices", "collapsePagesss")}
                                    >
                                      <div>
                                        <span className="arrow">&rarr;</span>Sparyers
                                      </div>
                                    </Link>
                                    <Link
                                      to="/FarmOperationsBoreWell"
                                      className={`collapse-item ${activeItem === "FarmOperationsBoreWell" ? "active" : ""}`}
                                      aria-expanded={activeItem === "FarmOperationsBoreWell" ? "true" : "false"}
                                      onClick={() => handleItemClick("FarmOperationsBoreWell", "collapsePagesss")}
                                    >
                                      <div>
                                        <span className="arrow">&rarr;</span>BoreWells
                                      </div>
                                    </Link>
                                    <Link
                                      to="/FarmOperationsGenaralMaintanance"
                                      className={`collapse-item ${activeItem === "FarmOperationsGenaralMaintanance" ? "active" : ""}`}
                                      aria-expanded={activeItem === "FarmOperationsGenaralMaintanance" ? "true" : "false"}
                                      onClick={() => handleItemClick("FarmOperationsGenaralMaintanance", "collapsePagesss")}
                                    >
                                      <div>
                                        <span className="arrow">&rarr;</span>Genaral Maintanance
                                      </div>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </li>
                            <div className="aster collapse-inner rounded">
                              <Link
                                to="/FarmOperationHistory"
                                className={`collapse-item ${activeItem === "FarmOperationHistory" ? "active" : ""}`}
                                aria-expanded={activeItem === "FarmOperationHistory" ? "true" : "false"}
                                onClick={() => handleItemClick("FarmOperationHistory", "collapsePagesss")}
                              >
                                <div>
                                  <span className="arrow">&rarr;</span>R & M History
                                </div>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </li>
                      <div
                        className="aster collapse-inner rounded"
                        style={{ marginTop: "-18px" }}
                      >
                        <Link
                          to="/FarmOperationHistoryAll"
                          className={`collapse-item ${activeItem === "FarmOperationHistoryAll" ? "active" : ""}`}
                          aria-expanded={activeItem === "FarmOperationHistoryAll" ? "true" : "false"}
                          onClick={() => handleItemClick("FarmOperationHistoryAll", "collapsePagesss")}
                        >
                          <div>
                            <span className="arrow">&rarr;</span>History
                          </div>
                        </Link>
                        <Link
                          to="/FarmOperationsReports"
                          className={`collapse-item ${activeItem === "FarmOperationsReports" ? "active" : ""}`}
                          aria-expanded={activeItem === "FarmOperationsReports" ? "true" : "false"}
                          onClick={() => handleItemClick("FarmOperationsReports", "collapsePagesss")}
                        >
                          <div>
                            <span className="arrow">&rarr;</span>Reports
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>
              ) : (
                ""
              )}
            </>
            <>
              <li className="centalStr nav-item">
                <a
                  className={`nav-link ${isCollapsed ? "collapsed" : ""}`}
                  href="#"
                  data-toggle="collapse"
                  data-target="#collapsePagesMan"
                  aria-expanded={isCollapsed ? "false" : "true"}
                  aria-controls="collapsePagesMan"
                  style={{
                    marginTop: "3px"
                  }}
                >
                  <span style={{ width: "22px", display: "inline-block" }}>
                    <img
                      src={ManPower}
                      alt="Tracking"
                      width="18px"
                      height="18px"
                      // style={{ marginRight: "5px", marginBottom: "6px" }}
                      style={{ transform: "translateX(-3px)", marginBottom: "6px" }}
                    />
                  </span>
                  <span style={{ fontSize: 16, marginTop: 4, fontWeight: 600, marginLeft: "2px", }}>
                    Man Power
                  </span>
                </a>
                <div
                  id="collapsePagesMan"
                  // className={`collapse ${isCollapsed ? "" : "show"}`}
                  className={`collapse ${expandedItems.includes("collapsePagesMan") ? "show" : ""}`}
                  aria-labelledby="headingPages"
                  data-parent="#accordionSidebar"
                >
                  <div className="centalStrAptr py-2 collapse-inner rounded">
                    <Link
                      to="/EmployeeList"
                      className={`collapse-item ${activeItem === "EmployeeList" ? "active" : ""}`}
                      // style={{
                      //   color: activeItem === "EmployeeList" ? "#000" : "white",
                      //   backgroundColor: activeItem === "EmployeeList" ? "#dddfeb" : "transparent",
                      // }}
                      aria-expanded={activeItem === "EmployeeList" ? "true" : "false"}
                      onClick={() => handleItemClick("EmployeeList", "collapsePages")}
                    >
                      {" "}
                      <div>
                        <span className="arrow">&rarr;</span>
                        Employee List
                      </div>
                    </Link>
                  </div>
                </div>
              </li>
            </>
          </>
        ) : (
          <>
            <>
              {itemClicked === "centralStore" ? (
                <li className="centalStr nav-item">
                  <a
                    className={`nav-link ${isCollapsed ? "collapsed" : ""}`}
                    href="#"
                    data-toggle="collapse"
                    data-target="#collapsePages"
                    aria-expanded={isCollapsed ? "false" : "true"}
                    aria-controls="collapsePages"
                  >
                    <img
                      src={CentralLogo}
                      alt="Tracking"
                      width="17px"
                      height="17px"
                      style={{ marginRight: "5px", opacity: 3 }}
                    />
                    <span
                      style={{ fontSize: 16, marginTop: 4, fontWeight: 600 }}
                    >
                      Central Store
                    </span>
                  </a>
                  <div
                    id="collapsePage"
                    className={`collapse ${expandedItems.includes("collapsePages") ? "show" : ""}`}
                    aria-labelledby="headingPages"
                    data-parent="#accordionSidebar"
                  >
                    <li className="centalStrAptr nav-item">
                      <a
                        className={`nav-link px-0 ${isCollapsed ? "collapsed" : ""
                          }`}
                        href="#"
                        data-toggle="collapse"
                        data-target="#collapsePagesss"
                        aria-expanded={isCollapsed ? "false" : "true"}
                        aria-controls="collapsePagesss"
                      >
                        <span style={{ width: "22px", display: "inline-block" }}>
                          <img
                            src={MasterIcon}
                            alt="Tracking"
                            width="15px"
                            height="15px"
                            style={{ marginRight: "5px" }}
                          />
                        </span>
                        <span
                          style={{
                            fontSize: 14,
                            marginTop: 4,
                            fontWeight: 600,
                          }}
                        >
                          Masters
                        </span>
                      </a>
                      <div
                        id="collapsePagesss"
                        className={`collapse ${isSubCollapsed ? "" : "show"}`}
                        aria-labelledby="headingSubPage"
                      //  data-parent="#collapsePages"
                      >
                        <div className="master py-2 collapse-inner rounded">
                          <div classname="active">
                            <Link
                              to="/UnitMeasureMaster"
                              className="collapse-item"
                              style={{ color: "white" }}
                              aria-expanded="true"
                            >
                              {" "}
                              <div>
                                <span className="arrow ">&rarr;</span>Unit
                                Measure Master
                              </div>
                            </Link>
                            <Link
                              to="/CategoryMaster"
                              className="collapse-item"
                              style={{ color: "white" }}
                              aria-expanded="true"
                            >
                              {" "}
                              <div>
                                <span className="arrow">&rarr;</span>Category
                                Master
                              </div>
                            </Link>

                            <Link
                              to="/ProductMaster"
                              className="collapse-item"
                              style={{ color: "white" }}
                              aria-expanded="true"
                            >
                              {" "}
                              <div>
                                <span className="arrow">&rarr;</span>Product
                                Master
                              </div>
                            </Link>
                            <Link
                              to="/MainStoreMaster"
                              className="collapse-item"
                              style={{ color: "white" }}
                              aria-expanded="true"
                            >
                              {" "}
                              <div>
                                <span className="arrow">&rarr;</span>Main Store
                                Master
                              </div>
                            </Link>
                            <Link
                              to="/storemaster"
                              className="collapse-item"
                              style={{ color: "white" }}
                              aria-expanded="true"
                            >
                              {" "}
                              <div>
                                <span className="arrow">&rarr;</span>Store
                                Master
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="centalStrAptr nav-item">
                      <a
                        className={`nav-link px-0 ${isCollapsed ? "collapsed" : ""
                          }`}
                        href="#"
                        data-toggle="collapse"
                        data-target="#collapseSubPagesss"
                        aria-expanded={isCollapsed ? "false" : "true"}
                        aria-controls="collapseSubPagesss"
                      >
                        <img
                          src={Tracking}
                          alt="Tracking"
                          width="15px"
                          height="15px"
                          style={{ marginRight: "5px" }}
                        />
                        <span
                          style={{
                            fontSize: 14,
                            marginTop: 4,
                            fontWeight: 600,
                          }}
                        >
                          Acceptor
                        </span>
                      </a>
                      <div
                        id="collapseSubPagesss"
                        className={`collapse ${isSubCollapsed ? "" : "show"}`}
                        aria-labelledby="headingSubPage"
                      //  data-parent="#collapsePages"
                      >
                        <div className="master py-2 collapse-inner rounded">
                          <div>
                            <Link
                              to="/StockInWard"
                              className="collapse-item"
                              style={{ color: "white" }}
                              aria-expanded="true"
                            >
                              {" "}
                              <div>
                                <span className="arrow">&rarr;</span>
                                Stock-In-Ward
                              </div>
                            </Link>
                            <Link
                              to="/OpenStock"
                              className="collapse-item"
                              style={{ color: "white" }}
                              aria-expanded="true"
                            >
                              {" "}
                              <div>
                                <span className="arrow">&rarr;</span>Open Stock
                              </div>
                            </Link>
                            <Link
                              to="/RequestedOrderHistory"
                              className="collapse-item"
                              style={{ color: "white" }}
                              aria-expanded="true"
                            >
                              {" "}
                              <div>
                                <span className="arrow">&rarr;</span>Requests
                              </div>
                            </Link>

                            <Link
                              to="/ReturnOrderHistory"
                              className="collapse-item"
                              style={{ color: "white" }}
                              aria-expanded="true"
                            >
                              {" "}
                              <div>
                                <span className="arrow">&rarr;</span>Returns
                              </div>
                            </Link>
                            <Link
                              to="/ProductStatus"
                              className="collapse-item"
                              style={{ color: "white" }}
                              aria-expanded="true"
                            >
                              {" "}
                              <div>
                                <span className="arrow">&rarr;</span>Product
                                Status
                              </div>
                            </Link>
                            <Link
                              to="/history"
                              className="collapse-item"
                              style={{ color: "white" }}
                              aria-expanded="true"
                            >
                              {" "}
                              <div>
                                <span className="arrow">&rarr;</span>History
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </li>
                    {/* Cs Reports */}
                    <li className="centalStrAptr nav-item">
                      <a
                        className={`nav-link  px-0 ${isCollapsed ? "collapsed" : ""
                          }`}
                        href="#"
                        data-toggle="collapse"
                        data-target="#collapseSubPagesReports"
                        aria-expanded={isCollapsed ? "false" : "true"}
                        aria-controls="collapseSubPagesReports"
                      >
                        <img
                          src={reportsmenuicon}
                          alt="reportsmenuicon"
                          width="15px"
                          height="15px"
                          style={{ marginRight: " 5px" }}
                        />
                        <span
                          style={{
                            marginRight: "11px",
                            fontSize: 14,
                            marginTop: 4,
                            fontWeight: 600,
                          }}
                        >
                          Reports
                        </span>
                      </a>
                      <div
                        id="collapseSubPagesReports"
                        className={`collapse ${isSubCollapsed ? "" : "show"}`}
                        aria-labelledby="headingSubPage"
                      //  data-parent="#collapsePages"
                      >
                        <div className="master py-2 collapse-inner rounded">
                          <div>
                            <Link
                              to="/stockInwardReport"
                              className="collapse-item"
                              style={{ color: "white" }}
                              aria-expanded="true"
                            >
                              {" "}
                              <div>
                                <span className="arrow">&rarr;</span>
                                Stock-In-ward
                              </div>
                            </Link>

                            <Link
                              to="/requestReport"
                              className="collapse-item"
                              style={{ color: "white" }}
                              aria-expanded="true"
                            >
                              {" "}
                              <div>
                                <span className="arrow">&rarr;</span>
                                Request
                              </div>
                            </Link>

                            <Link
                              to="/returnReport"
                              className="collapse-item"
                              style={{ color: "white" }}
                              aria-expanded="true"
                            >
                              {" "}
                              <div>
                                <span className="arrow">&rarr;</span>
                                Return
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </li>
                  </div>
                </li>
              ) : (
                ""
              )}
            </>
            <>
              {itemClicked === "rmTracking" ? (
                <li className="centalStr nav-item">
                  <a
                    className={`nav-link ${isCollapsed ? "collapsed" : ""}`}
                    href="#"
                    data-toggle="collapse"
                    data-target="#collapsePag"
                    aria-expanded={isCollapsed ? "false" : "true"}
                    aria-controls="collapsePag"
                  >
                    <span style={{ width: "22px", display: "inline-block" }}>
                      <img
                        src={UserMaster}
                        alt="Tracking"
                        width="17px"
                        height="17px"
                        style={{ marginRight: "5px", opacity: "3" }}
                      />
                    </span>
                    <span>R & M Tracking</span>
                  </a>

                  <div
                    id="collapsePag"
                    className={`collapse ${isCollapsed ? "" : "show"}`}
                    aria-labelledby="headingPages"
                    data-parent="#accordionSidebar"
                  >
                    <div className="userMgt py-2 collapse-inner rounded">
                      <div>
                        <Link
                          to="/WorkPermit"
                          className="collapse-item"
                          style={{ color: "white" }}
                          aria-expanded="true"
                        >
                          {" "}
                          <div>
                            <span className="arrow">&rarr;</span>Work Permit
                          </div>
                        </Link>
                        <Link
                          to="/RepairMaintenace"
                          className="collapse-item"
                          style={{ color: "white" }}
                          aria-expanded="true"
                        >
                          {" "}
                          <div>
                            <span className="arrow">&rarr;</span>R & M
                          </div>
                        </Link>
                        <Link
                          to="/NewRequest"
                          className="collapse-item"
                          style={{ color: "white" }}
                          aria-expanded="true"
                        >
                          {" "}
                          <div>
                            <span className="arrow">&rarr;</span>New Requests
                          </div>
                        </Link>

                        <Link
                          to="/DailyWorkAllocation"
                          className="collapse-item"
                          style={{ color: "white" }}
                          aria-expanded="true"
                        >
                          {" "}
                          <div>
                            <span className="arrow">&rarr;</span>Daily Work
                            Allocation
                          </div>
                        </Link>

                        <Link
                          to="/EquipmentMonitoring"
                          className="collapse-item"
                          style={{ color: "white" }}
                          aria-expanded="true"
                        >
                          {" "}
                          <div>
                            <span className="arrow">&rarr;</span>Preventive
                            Maintenance
                          </div>
                        </Link>
                        <Link
                          to="/BulkAllocation"
                          className="collapse-item"
                          style={{ color: "white" }}
                          aria-expanded="true"
                        >
                          {" "}
                          <div>
                            <span className="arrow">&rarr;</span>BulkAllocation
                          </div>
                        </Link>
                        <Link
                          to="/RMhistory"
                          className="collapse-item"
                          style={{ color: "white" }}
                          aria-expanded="true"
                        >
                          {" "}
                          <div>
                            <span className="arrow">&rarr;</span>History
                          </div>
                        </Link>
                        {/* R&M Reports */}
                        <div>
                          <li>
                            <a
                              className={`nav-link px-0
                            
                              ${isCollapsed ? "collapsed" : ""}`}
                              href="#"
                              data-toggle="collapse"
                              data-target="#collapseSubPagerm"
                              aria-expanded={isCollapsed ? "false" : "true"}
                              aria-controls="collapseSubPagerm"
                              style={{ width: "100%" }}
                            >
                              <img
                                src={reportsmenuicon}
                                alt="reportsmenuicon"
                                width="15px"
                                height="15px"
                                style={{
                                  marginRight: "5px",
                                  width: "20px",
                                  height: "22px",
                                }}
                              />
                              <span
                                style={{
                                  fontSize: 14,
                                  marginTop: 4,
                                  fontWeight: 600,
                                  color: "white",
                                }}
                              >
                                Report
                              </span>
                            </a>
                            <div
                              id="collapseSubPagerm"
                              className={`collapse ${isSubCollapsed ? "" : "show"
                                }`}
                              aria-labelledby="headingSubPage"
                            //  data-parent="#collapsePages"
                            >
                              <div className="master py-2 ">
                                <div>
                                  <Link
                                    to="/workPermitReport"
                                    className="collapse-item"
                                    style={{ color: "white" }}
                                    aria-expanded="true"
                                  >
                                    {" "}
                                    <div>
                                      <span className="arrow">&rarr;</span>
                                      Work Permit
                                    </div>
                                  </Link>
                                  <Link
                                    to="/rMReport"
                                    className="collapse-item"
                                    style={{ color: "white" }}
                                    aria-expanded="true"
                                  >
                                    {" "}
                                    <div>
                                      <span className="arrow">&rarr;</span>
                                      R&M
                                    </div>
                                  </Link>
                                  <Link
                                    to="/newRequestReport"
                                    //to="/NewRequest"
                                    className="collapse-item"
                                    style={{ color: "white" }}
                                    aria-expanded="true"
                                  >
                                    {" "}
                                    <div>
                                      <span className="arrow">&rarr;</span>
                                      New Request
                                    </div>
                                  </Link>

                                  <Link
                                    to="/DailyWorkAllocationReport"
                                    className="collapse-item"
                                    style={{ color: "white" }}
                                    aria-expanded="true"
                                  >
                                    {" "}
                                    <div>
                                      <span className="arrow">&rarr;</span>
                                      Daily Work Allocation
                                    </div>
                                  </Link>

                                  <Link
                                    to="/ShiftBasedReport"
                                    className="collapse-item"
                                    style={{ color: "white" }}
                                    aria-expanded="true"
                                  >
                                    {" "}
                                    <div>
                                      <span className="arrow">&rarr;</span>
                                      Shift Based
                                    </div>
                                  </Link>

                                  <Link
                                    to="/EquipmentMonitoringReport"
                                    className="collapse-item"
                                    style={{ color: "white" }}
                                    aria-expanded="true"
                                  >
                                    {" "}
                                    <div>
                                      <span className="arrow">&rarr;</span>
                                      {/* Equipment Monitoring */}
                                      Preventive Maintenance
                                    </div>
                                  </Link>

                                  <Link
                                    to="/BulkAllocationReport"
                                    className="collapse-item"
                                    style={{ color: "white" }}
                                    aria-expanded="true"
                                  >
                                    {" "}
                                    <div>
                                      <span className="arrow">&rarr;</span>
                                      BulkAllocation
                                    </div>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </li>
                        </div>
                      </div>
                    </div>
                  </div>

                </li>
              ) : (
                ""
              )}
            </>
            <>
              {itemClicked === "farmOperations" ? (
                <li className="centalStr nav-item">
                  <a
                    className={`nav-link ${isCollapsed ? "collapsed" : ""}`}
                    href="#"
                    data-toggle="collapse"
                    data-target="#collapsePagesFarm"
                    aria-expanded={isCollapsed ? "false" : "true"}
                    aria-controls="collapsePagesFarm"
                  // onClick={toggleCollapse}
                  >
                    <span style={{ width: "22px", display: "inline-block" }}>
                      <img
                        src={FarmlogoSidemenu}
                        alt="Tracking"
                        width="17px"
                        height="18px"
                        style={{ marginRight: "5px", marginBottom: "6px" }}
                      />
                    </span>
                    <span
                      style={{ fontSize: 16, marginTop: 4, fontWeight: 600 }}
                    >
                      Farm Operations
                    </span>
                  </a>
                  <div
                    id="collapsePagesFarm"
                    className={`collapse ${isCollapsed ? "" : "show"}`}
                    aria-labelledby="headingPages"
                    data-parent="#accordionSidebar"
                  >
                    <div className="centalStrAptr py-2 collapse-inner rounded">
                      <Link
                        to="/RequestFarmOperation"
                        className="collapse-item"
                        style={{ color: "white" }}
                        aria-expanded="true"
                      >
                        {" "}
                        <div>
                          <span className="arrow">&rarr;</span>Requests
                        </div>
                      </Link>
                      <Link
                        to="/UpdateActivity"
                        className="collapse-item"
                        style={{ color: "white" }}
                        aria-expanded="true"
                      >
                        {" "}
                        <div>
                          <span className="arrow">&rarr;</span>Update Activity
                        </div>
                      </Link>

                      <li className="centalStrAptr nav-item">
                        <a
                          className={`nav-link px-0 ${isCollapsed ? "collapsed" : ""
                            }`}
                          href="#"
                          data-toggle="collapse"
                          data-target="#collapsePagesss"
                          aria-expanded={isCollapsed ? "false" : "true"}
                          aria-controls="collapsePagesss"
                          style={{ marginTop: "11px" }}
                        >
                          <span className="arrow">&rarr;</span>
                          <span
                            style={{
                              fontSize: 14,
                              marginTop: 4,
                              fontWeight: 600,
                            }}

                          >
                            R&M Activity
                          </span>
                        </a>
                        <div
                          id="collapsePagesss"
                          className={`collapse ${isSubCollapsed ? "" : "show"}`}
                          aria-labelledby="headingSubPage"
                          //  data-parent="#collapsePages"
                          style={{ marginLeft: "0px", marginRight: "0px" }}
                        >
                          <div className="master py-2 collapse-inner rounded mt-0">
                            <li className="centalStrAptr nav-item">
                              <a
                                className={`nav-link px-0 ${isCollapsed ? "collapsed" : ""
                                  }`}
                                href="#"
                                data-toggle="collapse"
                                data-target="#collapseSubPagesss"
                                aria-expanded={isCollapsed ? "false" : "true"}
                                aria-controls="collapseSubPagesss"
                                style={{ marginTop: "-28px" }}
                              >

                                <span
                                  className="arrow mt-3"
                                  style={{ fontSize: 14, fontWeight: 600 }}
                                >
                                  &rarr;
                                </span>
                                Machines/Systems
                              </a>
                              <div
                                id="collapseSubPagesss"
                                className={`collapse ${isSubCollapsed ? "" : "show"
                                  }`}
                                aria-labelledby="headingSubPage"
                              //  data-parent="#collapsePages"
                              >
                                <div className="master py-2 collapse-inner rounded">
                                  <div>
                                    <Link
                                      to="/FarmOperationsDripSystem"
                                      className="collapse-item"
                                      style={{ color: "white" }}
                                      aria-expanded="true"
                                    >
                                      {" "}
                                      <div>
                                        <span className="arrow">&rarr;</span>
                                        Drip Systems
                                      </div>
                                    </Link>
                                    <Link
                                      to="/FarmOperationsImplements"
                                      className="collapse-item"
                                      style={{ color: "white" }}
                                      aria-expanded="true"
                                    >
                                      {" "}
                                      <div>
                                        <span className="arrow">&rarr;</span>
                                        Implements
                                      </div>
                                    </Link>
                                    <Link
                                      to="/FarmOperationsDG"
                                      className="collapse-item"
                                      style={{ color: "white" }}
                                      aria-expanded="true"
                                    >
                                      {" "}
                                      <div>
                                        <span className="arrow">&rarr;</span>DG
                                      </div>
                                    </Link>
                                    <Link
                                      to="/FarmOperationsTractors"
                                      className="collapse-item"
                                      style={{ color: "white" }}
                                      aria-expanded="true"
                                    >
                                      {" "}
                                      <div>
                                        <span className="arrow">&rarr;</span>
                                        Tractors
                                      </div>
                                    </Link>
                                    <Link
                                      to="/FarmOperationsSprayServices"
                                      className="collapse-item"
                                      style={{ color: "white" }}
                                      aria-expanded="true"
                                    >
                                      {" "}
                                      <div>
                                        <span className="arrow">&rarr;</span>
                                        Sparyers
                                      </div>
                                    </Link>
                                    <Link
                                      to="/FarmOperationsBoreWell"
                                      className="collapse-item"
                                      style={{ color: "white" }}
                                      aria-expanded="true"
                                    >
                                      {" "}
                                      <div>
                                        <span className="arrow">&rarr;</span>
                                        BoreWells
                                      </div>
                                    </Link>
                                    <Link
                                      to="/FarmOperationsGenaralMaintanance"
                                      className="collapse-item"
                                      style={{ color: "white" }}
                                      aria-expanded="true"
                                    >
                                      {" "}
                                      <div>
                                        <span className="arrow">&rarr;</span>
                                        Genaral Maintanance
                                      </div>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </li>
                            <div className="aster collapse-inner rounded">
                              <Link
                                to="/FarmOperationHistory"
                                className="collapse-item"
                                style={{
                                  color: "white",
                                  marginTop: "-20px",
                                }}
                                aria-expanded="true"
                              >
                                {" "}
                                <div>
                                  <span className="arrow">&rarr;</span> R & M
                                  History
                                </div>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </li>
                      <div
                        className="aster collapse-inner rounded"
                        style={{ marginTop: "-18px" }}
                      >
                        <Link
                          to="/FarmOperationHistoryAll"
                          className="collapse-item"
                          style={{ color: "white" }}
                          aria-expanded="true"
                        >
                          {" "}
                          <div style={{ height: "23px" }}>
                            <span className="arrow">&rarr;</span>History
                          </div>
                        </Link>

                        <Link
                          to="/FarmOperationsReports"
                          className="collapse-item"
                          style={{ color: "white" }}
                          aria-expanded="true"
                        >
                          {" "}
                          <div>
                            <span className="arrow">&rarr;</span>Reports
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>
              ) : (
                ""
              )}
            </>
          </>
        )}
      </ul >
    </>
  );
}
export default SideMenu;
